import { NgModule } from '@angular/core';
import { BusinessImageDirective } from './Directives/business-image.directive';

/** Share the existing bounded image loader with lazy standalone views. */
@NgModule({ declarations: [BusinessImageDirective], exports: [BusinessImageDirective] })
export class BusinessImagesModule {}
